<div class="order-history-panel">
    <div class="order-history-content">
        <!-- Loading -->
        <div *ngIf="isLoading" class="order-history-state">
            <mat-spinner diameter="40"></mat-spinner>
        </div>

        <!-- Error -->
        <div *ngIf="!isLoading && hasError" class="order-history-state">
            <mat-icon>error_outline</mat-icon>
            <p>Failed to load order history</p>
            <button mat-stroked-button (click)="loadHistory()">Retry</button>
        </div>

        <!-- Empty -->
        <div *ngIf="!isLoading && !hasError && events.length === 0" class="order-history-state">
            <mat-icon>history</mat-icon>
            <p>No history recorded for this order yet.</p>
        </div>

        <!-- Events -->
        <div *ngIf="!isLoading && !hasError && events.length > 0" class="order-history-events">
            <div *ngFor="let event of events; let i = index" class="order-history-event-wrapper">
                <app-order-history-event
                    [event]="event"
                    [isExpanded]="expandedIndex === i"
                    (toggleExpand)="expandedIndex = expandedIndex === i ? -1 : i">
                </app-order-history-event>
            </div>
        </div>
    </div>
</div>
